import React from 'react';
import PropTypes from 'prop-types';

import Link from '~/src/components/link/Link';
import {withSettingsContext} from '~/src/components/context/SettingsContext';

import {classNames} from '~/src/utilities/helpers/css';

import css from './NavigationItem.module.scss';

const NavigationItem = ({href, target, label, format, flags, context, forwardRef, onClick}) => {
    const {siteArea, isWebView} = context.settings;
    const className = classNames(css, 'item', format, siteArea, flags, {isWebView});

    return (
        <li ref={forwardRef} className={className} data-testid="NavigationItem">
            <Link className={css.link} href={href} target={target} title={label} onClick={onClick}>
                <span className={css.label}>{label}</span>
            </Link>
        </li>
    );
};

if (process.env.NODE_ENV === 'development') {
    NavigationItem.propTypes = {
        href: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        format: PropTypes.string,
        flags: PropTypes.object
    };
}

export default withSettingsContext(NavigationItem);
